import { Handle, Position } from "@xyflow/react";
import { LINEAR_HANDLE } from "../../utils/workflowPaletteConstants";

const HANDLE_SIZE = { width: 12, height: 12 };

/** UI-only workflow entry marker — not saved to API definition.nodes. */
export function WorkflowStartNode({ isConnectable }) {
  return (
    <>
      <div className="w-[76px] h-[76px] rounded-full border-2 border-[#0F6E56] dark:border-emerald-500 bg-[#E1F5EE] dark:bg-emerald-950/60 shadow-md flex items-center justify-center">
        <span className="text-[11px] font-bold uppercase tracking-wide text-[#085041] dark:text-emerald-300">
          Start
        </span>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        id={LINEAR_HANDLE}
        isConnectable={isConnectable}
        style={HANDLE_SIZE}
        className="border-2 border-white dark:border-slate-900 shadow-sm bg-[#0F6E56] dark:bg-emerald-500"
      />
    </>
  );
}
